<template>
  <teleport :to="'#' + id">
    <div class="ds-flash-message">
      <transition name="slide">
        <BaseNotification
          v-if="isOpen"
          :type="$props.type"
          v-bind="$props"
          class="ds-flash-message__notification"
        >
          <slot />
        </BaseNotification>
      </transition>
    </div>
  </teleport>
</template>

<script>
import BaseNotification from './BaseNotification.vue';
import notificationProps from './notificationProps';

// WARNING: This component requires
// import PortalVue from 'portal-vue';
// Vue.use(PortalVue);
// in the Vue entrypoint.
export default {
  name: 'FlashMessage',

  emits: ['close'],

  mixins: [notificationProps],

  components: { BaseNotification },

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    closeTimeout: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      id: `flash-message-${Math.floor(Math.random() * 1000000)}`,
      timeout: null,
    };
  },
  watch: {
    isOpen(value) {
      if (value) {
        this.timeout = setTimeout(() => {
          this.$emit('close');
          this.timeout = null;
        }, this.closeTimeout);
      }
    },
  },
  created() {
    const elementToReplace = document.createElement('div');
    elementToReplace.id = this.id;

    document.body.appendChild(elementToReplace);
  },
  unmounted() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  },
};
</script>

<style lang="scss" scoped>
$top: 40px;
$mobileTop: 50px;
@use "@sass/design-system/variables" as ds-variables;
@use "@sass/base/variables";

.ds-flash-message__notification {
  position: fixed;
  top: $top;

  left: 50%;
  transform: translateX(-50%);

  min-width: 300px;
  width: auto;
  max-width: 100%;

  z-index: 1000000000;

  @media #{variables.$for-mobile} {
    top: $mobileTop;
  }
}

.ds-flash-message {
  .slide-enter-active, .slide-leave-active {
    transition: top .4s ease-out;
  }

  .slide-enter, .slide-leave-to {
    top: -100px !important;
  }

  .slide-enter-to, .slide-leave {
    top: $top !important;

    @media #{variables.$for-mobile} {
      top: $mobileTop !important;
    }
  }
}
</style>
